import { List } from 'immutable';
import identity from 'transmute/identity';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
import IndexUIActions from 'SalesContentIndexUI/data/actions/IndexUIActions';
import PresentationRecord from 'documents-lib/js/records/PresentationRecord';
import { updateDocumentBrandInIndex } from 'documents-ui/utils/updateDocumentBrandInIndex';
import { PRESENTATION_ACTION_TYPES, DOCUMENTS_USAGE_FETCH_SUCCEEDED, DOCUMENTS_USAGE_CHIRP_FETCH_SUCCEEDED, DOCUMENTS_DELETE_SUCCEEDED, DOCUMENTS_CHIRP_REMOVE_SUCCEEDED, MOVE_DOCUMENT_TO_FOLDER_STARTED, DOCUMENT_UPDATE_SUCCEEDED, DOCUMENT_CHIRP_UPDATE_SUCCEEDED, DOCUMENT_BRAND_UPDATE_SUCCEEDED, DOWNLOAD_DOCUMENT_STARTED, FETCH_DOCUMENT_DESCRIPTION_SUCCEEDED, FETCH_DOCUMENT_DESCRIPTION_FAILED, FETCH_DOCUMENT_DESCRIPTION_CHIRP_SUCCEEDED, FETCH_DOCUMENT_DESCRIPTION_CHIRP_FAILED, TOGGLE_DOCUMENT_DESCRIPTION } from 'documents-lib/js/constants/ActionTypes';
import * as DocumentDescriptionApi from 'documents-ui/api/DocumentDescriptionApi';
import * as DocumentsApi from 'documents-ui/api/DocumentsApi';
import * as BrandingPublicApi from 'documents-ui/api/BrandingPublicApi';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { isMultiBrandEnabled } from 'documents-lib/js/utils/isMultiBrandEnabled';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import documentToSearchResult, { documentToSearchResultCHIRP } from 'documents-ui/utils/documentToSearchResult';
import { buildPublicSharedLinkView } from 'documents-ui/utils/previewUtils';
import UserContainer from 'documents-ui/lib/containers/UserContainer';
import { ACCOUNT_BRAND_ID } from '../constants/BrandConstants';
import Raven from 'raven-js';
const {
  PRESENTATION_FETCH_SUCCEEDED,
  PRESENTATION_FETCH_FAILED,
  PRESENTATION_NOT_FOUND,
  PRESENTATION_FETCH_FAILED_NO_PERMISSION,
  PUBLIC_SHARED_LINK_FETCH_SUCCEEDED
} = PRESENTATION_ACTION_TYPES;
export const fetchDocumentsUsageSucceeded = createAction(DOCUMENTS_USAGE_FETCH_SUCCEEDED, identity);
export const fetchDocumentsUsageChirpSucceeded = createAction(DOCUMENTS_USAGE_CHIRP_FETCH_SUCCEEDED, identity);
export const moveDocumentStarted = createAction(MOVE_DOCUMENT_TO_FOLDER_STARTED, identity);
export const removeDocumentsSuccess = createAction(DOCUMENTS_DELETE_SUCCEEDED, identity);
export const removeDocumentsChirpSuccess = createAction(DOCUMENTS_CHIRP_REMOVE_SUCCEEDED, payload => payload);
export const updateDocumentSuccess = createAction(DOCUMENT_UPDATE_SUCCEEDED, identity);
export const updateDocumentSuccessCHIRP = createAction(DOCUMENT_CHIRP_UPDATE_SUCCEEDED, payload => payload);
export const updateDocumentBrandSuccess = createAction(DOCUMENT_BRAND_UPDATE_SUCCEEDED, (documentId, brandId) => ({
  documentId,
  brandId
}));
export const downloadDocumentStarted = createAction(DOWNLOAD_DOCUMENT_STARTED, identity);
const fetchPresentationSuccess = createAction(PRESENTATION_FETCH_SUCCEEDED, identity);
export const fetchPresentationFailed = createAction(PRESENTATION_FETCH_FAILED, identity);
export const fetchPresentationNotFound = createAction(PRESENTATION_NOT_FOUND, identity);
export const fetchPublicSharedLinkSucceeded = createAction(PUBLIC_SHARED_LINK_FETCH_SUCCEEDED, identity);
export const fetchPresentationNoPermission = createAction(PRESENTATION_FETCH_FAILED_NO_PERMISSION, identity);
export const fetchDocumentDescriptionSucceeded = createAction(FETCH_DOCUMENT_DESCRIPTION_SUCCEEDED, identity);
export const fetchDocumentDescriptionFailed = createAction(FETCH_DOCUMENT_DESCRIPTION_FAILED, identity);
export const fetchDocumentDescriptionChirpSucceeded = createAction(FETCH_DOCUMENT_DESCRIPTION_CHIRP_SUCCEEDED, identity);
export const fetchDocumentDescriptionChirpFailed = createAction(FETCH_DOCUMENT_DESCRIPTION_CHIRP_FAILED, identity);
export const toggleDocumentDescriptionSucceeded = createAction(TOGGLE_DOCUMENT_DESCRIPTION, identity);
export const moveDocuments = (documentSearchResults, folderSearchResult) => dispatch => {
  const {
    name
  } = folderSearchResult;
  const contentIds = documentSearchResults.map(
  // TODO: Reconsider falling back to 0 - filter out null values instead
  documentResult => documentResult.contentId || 0);
  const ids = documentSearchResults.map(documentResult => documentResult.id || '');
  const removeFromFolder = folderSearchResult.contentId === 0 ? null : folderSearchResult.contentId;
  const folderWillNotChange = documentSearchResults.every(documentResult => {
    return documentResult.folderId === removeFromFolder || !('folderId' in documentResult) && !removeFromFolder;
  });
  if (folderWillNotChange) {
    return;
  }
  dispatch(moveDocumentStarted({
    removeFromFolder
  }));
  const isUngated = isUngatedToCHIRPEndpoints();
  const movePromise = isUngated ? DocumentsApi.moveDocumentsCHIRP(contentIds, removeFromFolder) : DocumentsApi.moveDocuments(contentIds, removeFromFolder);
  movePromise.then(() => {
    IndexUIActions.removeResults(ids.toList());
    addAlert('updatedFolder', 'success', {
      name
    });
  }).catch(() => {
    addAlert('updatedFolder', 'danger', {
      name
    });
  });
};
export const removeDocumentsREST = searchResults => dispatch => {
  const contentIds = searchResults.map(
  // TODO: Reconsider falling back to 0 - filter out null values instead
  result => result.get('contentId') || 0);
  const ids = List(searchResults.map(result => result.get('id') || ''));
  const documents = searchResults.map(result => ({
    contentId: result.get('contentId') || 0,
    id: result.get('id') || ''
  }));
  return DocumentsApi.removeDocuments(contentIds).then(() => {
    var _searchResults$;
    dispatch(removeDocumentsSuccess(documents));
    IndexUIActions.removeResults(ids);
    addAlert('removeDocuments', 'success', {
      name: (_searchResults$ = searchResults[0]) === null || _searchResults$ === void 0 ? void 0 : _searchResults$.name,
      count: searchResults.length
    });
  }).catch(() => {
    var _searchResults$2;
    addAlert('removeDocuments', 'danger', {
      name: (_searchResults$2 = searchResults[0]) === null || _searchResults$2 === void 0 ? void 0 : _searchResults$2.name,
      count: searchResults.length
    });
  });
};
export const removeDocumentsCHIRP = searchResults => dispatch => {
  const documents = searchResults.map(result => ({
    // TODO: Reconsider falling back to 0 - filter out null values instead
    contentId: result.get('contentId') || 0,
    id: result.get('id') || ''
  }));
  const contentIds = documents.map(document => document.contentId);
  const ids = List(searchResults.map(result => result.get('id') || ''));
  return DocumentsApi.removeDocumentsCHIRP(contentIds).then(() => {
    var _searchResults$3;
    dispatch(removeDocumentsChirpSuccess(documents));
    IndexUIActions.removeResults(ids);
    addAlert('removeDocuments', 'success', {
      name: (_searchResults$3 = searchResults[0]) === null || _searchResults$3 === void 0 ? void 0 : _searchResults$3.name,
      count: searchResults.length
    });
  }).catch(() => {
    var _searchResults$4;
    addAlert('removeDocuments', 'danger', {
      name: (_searchResults$4 = searchResults[0]) === null || _searchResults$4 === void 0 ? void 0 : _searchResults$4.name,
      count: searchResults.length
    });
  });
};
export const removeDocuments = searchResults => dispatch => {
  const isUngated = isUngatedToCHIRPEndpoints();
  if (isUngated) {
    return removeDocumentsCHIRP(searchResults.toArray())(dispatch);
  }
  return removeDocumentsREST(searchResults.toArray())(dispatch);
};
export const removeDocument = documentData => {
  return removeDocuments(List([documentData]).toMap());
};
export const batchUpdateDocumentsBrand = (searchResults, brandId) => dispatch => {
  const documentIds = searchResults.map(result => result.contentId).filter(contentId => contentId !== null).toArray();
  return DocumentsApi.batchUpdateDocumentsBrand({
    documentIds,
    brandId
  }).then(() => {
    searchResults.forEach(result => {
      const contentId = result.contentId;
      updateDocumentBrandInIndex(result, brandId);
      dispatch(updateDocumentBrandSuccess(contentId, brandId));
    });
    addAlert('batchUpdateDocumentsBrand', 'success', {
      count: documentIds.length
    });
  }).catch(error => {
    addAlert('batchUpdateDocumentsBrand', 'danger', {});
    Raven.captureException(error, {
      extra: {
        context: 'Batch update documents brand error'
      }
    });
  });
};
export const updateDocument = ({
  documentId,
  folderId,
  title,
  isUngatedToChirp
}) => dispatch => {
  if (isUngatedToChirp) {
    return DocumentsApi.updateDocumentCHIRP({
      documentId,
      title
    }).then(updatedDocumentData => {
      dispatch(updateDocumentSuccessCHIRP(updatedDocumentData));
      IndexUIActions.updateResult(documentToSearchResultCHIRP(updatedDocumentData, UserContainer.get().user_id));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  return DocumentsApi.updateDocument({
    documentId,
    folderId,
    title
  }).then(updatedDocumentData => {
    dispatch(updateDocumentSuccess(updatedDocumentData));
    IndexUIActions.updateResult(documentToSearchResult(updatedDocumentData));
  }).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const downloadDocument = ({
  id,
  name
}) => dispatch => {
  dispatch(downloadDocumentStarted());
  return DocumentsApi.fetchDownloadLink(id).then(downloadUrlData => downloadUrlData.get('downloadUrl')).then(downloadUrl => {
    if (downloadUrl) {
      window.location.href = downloadUrl;
    }
  }).catch(() => {
    addAlert('download', 'danger', {
      name
    });
  });
};
export const fetchSharedLink = documentId => async dispatch => {
  try {
    const [document, pdfDownloadResponse] = await Promise.all([DocumentsApi.fetchDocumentCHIRPEarlyRequest(documentId), DocumentsApi.fetchPresentationPdfUrlCHIRP(documentId)]);
    const pdfUrl = (pdfDownloadResponse === null || pdfDownloadResponse === void 0 ? void 0 : pdfDownloadResponse.downloadUrl) || null;

    // TODO: Get brandId from CHIRP getDocument response once it is available
    const brandId = 0;
    const brandingRecord = await BrandingPublicApi.fetchBrandingForBrandId(brandId);
    const sharedLinkView = buildPublicSharedLinkView({
      document,
      pdfUrl,
      brandingRecord,
      user: UserContainer.get()
    });
    dispatch(fetchPublicSharedLinkSucceeded(sharedLinkView));
  } catch (err) {
    if ((err === null || err === void 0 ? void 0 : err.status) === 404) {
      dispatch(fetchPresentationNotFound(err));
    } else if ((err === null || err === void 0 ? void 0 : err.status) === 403) {
      dispatch(fetchPresentationNoPermission(err));
    } else {
      dispatch(fetchPresentationFailed(err));
    }
  }
};
export const fetchPresentation = documentId => async dispatch => {
  try {
    var _documentRecord$get;
    const [documentRecord, pdfLinkData] = await Promise.all([DocumentsApi.fetchDocument(documentId), DocumentsApi.fetchPresentationPdfUrl(documentId)]);
    const pdfDownloadUrl = pdfLinkData.get('downloadUrl');
    const brandId = isMultiBrandEnabled() ? (_documentRecord$get = documentRecord.get('brandId')) !== null && _documentRecord$get !== void 0 ? _documentRecord$get : ACCOUNT_BRAND_ID : undefined;
    const brandingMetadata = await BrandingPublicApi.fetchBrandingForBrandId(brandId);
    const presentation =
    // TODO: Remove this method when we have completely rolled out CHIRP migration
    PresentationRecord.convertFromDocumentRecord(documentRecord, pdfDownloadUrl, brandingMetadata, UserContainer);
    dispatch(fetchPresentationSuccess(presentation));
  } catch (err) {
    if ((err === null || err === void 0 ? void 0 : err.status) === 404) {
      dispatch(fetchPresentationNotFound(err));
    } else if ((err === null || err === void 0 ? void 0 : err.status) === 403) {
      dispatch(fetchPresentationNoPermission(err));
    } else {
      dispatch(fetchPresentationFailed(err));
    }
  }
};
export const fetchDownloadLink = deckId => () => isUngatedToCHIRPEndpoints() ? DocumentsApi.fetchDownloadLinkCHIRP(deckId).then(resp => (resp === null || resp === void 0 ? void 0 : resp.downloadUrl) || '') : DocumentsApi.fetchDownloadLink(deckId).then(downloadLinkData => downloadLinkData.get('downloadUrl'));
export const fetchDocumentsUsage = () => dispatch => {
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  if (isUngatedToChirp) {
    return DocumentsApi.fetchDocumentsUsageCHIRP().then(usageData => dispatch(fetchDocumentsUsageChirpSucceeded(usageData))).catch(error => {
      // Note: usage limits banner will not be displayed if the request fails
      console.error(error);
    });
  }
  return DocumentsApi.fetchDocumentsUsage().then(usageData => dispatch(fetchDocumentsUsageSucceeded(usageData))).catch(error => {
    // Note: usage limits banner will not be displayed if the request fails
    console.error(error);
  });
};

// Fetch AI generated document description
export const fetchDocumentDescription = deckId => dispatch => {
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  if (isUngatedToChirp) {
    return DocumentDescriptionApi.fetchDocumentDescriptionCHIRP(deckId).then(result => {
      dispatch(fetchDocumentDescriptionChirpSucceeded(result.documentSummary));
    }).catch(() => {
      dispatch(fetchDocumentDescriptionChirpFailed());
    });
  }
  return DocumentDescriptionApi.fetchDocumentDescriptionREST(deckId).then(result => {
    dispatch(fetchDocumentDescriptionSucceeded(result.deckSummary));
  }).catch(() => {
    dispatch(fetchDocumentDescriptionFailed());
  });
};
export const toggleDocumentDescription = payload => dispatch => {
  dispatch(toggleDocumentDescriptionSucceeded(payload));
};